module.exports = __webpack_public_path__ + "static/media/pdf_icon.09b9cb68.png";